import _ from 'underscore';
import Promise from 'bluebird';
import { AllStringsLoader } from '../lib/all-strings-loader';

export class UiNextLegacyI18nLoader extends AllStringsLoader {
  constructor({
    registry,
  }) {
    super({
      registry,
    });
    this.main = null; // Initialized in private\ui-next\packages\ui-next\src\app.js
    this.loadI18n = _.memoize(() => Promise.all([
      this.loadAllStrings(),
      this.loadI18nStatic(),
    ]));
    this.loadI18nWithMultipleCultures = _.memoize(() => Promise.all([
      this.loadAllStrings(),
      this.loadI18nStatic(),
      this.loadI18nMultipleCultures(),
    ]));
  }

  loadAllStrings() {
    return this.registry.loadAllStrings();
  }

  loadI18nStatic() {
    return this.registry.loadWebpackLegacyI18nBundle('i18nStatic', this.context.culture);
  }

  loadI18nMultipleCultures() {
    return this.registry.loadWebpackLegacyI18nBundle('i18nMultipleCultures', this.context.culture);
  }

  loadFooterSettingsI18n() {
    const loadWithWebpack = () => this.loadI18nStatic()
      .then(() => this.get('$/data!FooterSettings'));

    return loadWithWebpack();
  }
}
